import { useState } from 'react'
import { Input } from '../../Components/ui/input'
import { Button } from '../../Components/ui/button'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../Components/ui/tabs'
import UserBasketHoldings from './UserBasketHoldings'
import UserBasketOrderHistory from './UserBasketOrderHistory'
import UserIndividualHoldings from './UserIndividualHoldings'
import UserSips from './UserSIPs'
import UserBasketSIPs from './UserBasketSIPs'

const UserHoldings = () => {
  const [uccId, setUccId] = useState('')
  const [submittedClientCode, setSubmittedClientCode] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (uccId.trim()) {
      setSubmittedClientCode(uccId.trim().toUpperCase())
    }
  }
  return (
    <div className='w-full h-screen p-4'>
      <form onSubmit={handleSubmit} className='flex gap-x-7 items-center mb-6'>
        <div className='flex-[2]'>
          <Input
            placeholder='Enter Client Code'
            id='uccId'
            name='uccId'
            value={uccId}
            onChange={(e) => {
              setUccId(e.target.value)
              setSubmittedClientCode('')
            }}
          />
        </div>

        <Button type='submit' className='w-full text-lg max-w-[200px]'>
          SUBMIT
        </Button>
      </form>

      {submittedClientCode ? (
        <div>
          <h2 className='text-xl font-semibold mb-4'>
            Holdings for Client Code: {submittedClientCode}
          </h2>
          {/* Tab UI can go here */}
          <div className='max-w-[1128px] pt-12 mx-auto'>
            <Tabs defaultValue='userBasketHoldings' className='relative mr-auto w-full'>
              <TabsList className='w-full justify-start rounded-none border-b bg-transparent p-0'>
                <TabsTrigger
                  value='userBasketHoldings'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
                >
                  Users Basket Holdings
                </TabsTrigger>

                <TabsTrigger
                  value='userBasketOrderHistory'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
                >
                  Users Basket Order History
                </TabsTrigger>

                <TabsTrigger
                  value='userIndividualHoldings'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
                >
                  Users Individual Holdings
                </TabsTrigger>

                <TabsTrigger
                  value='UserSIPs'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
                >
                  SIPs
                </TabsTrigger>

                <TabsTrigger
                  value='BasketSIPs'
                  className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
                >
                  Basket SIPs
                </TabsTrigger>
              </TabsList>

              <TabsContent value='userBasketHoldings'>
                <UserBasketHoldings clientCode={submittedClientCode} />
              </TabsContent>

              <TabsContent value='userBasketOrderHistory'>
                <UserBasketOrderHistory clientCode={submittedClientCode} />
              </TabsContent>

              <TabsContent value='userIndividualHoldings'>
                <UserIndividualHoldings clientCode={submittedClientCode} />
              </TabsContent>

              <TabsContent value='UserSIPs'>
                <UserSips clientCode={submittedClientCode} />
              </TabsContent>

              <TabsContent value='BasketSIPs'>
                <UserBasketSIPs clientCode={submittedClientCode} />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      ) : (
        <p className='text-gray-600'>Enter Client code above to start</p>
      )}
    </div>
  )
}

export default UserHoldings
